import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("rg_token"));
  const [owner, setOwner] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    async function boot() {
      if (!token) { setLoading(false); return; }
      try {
        const r = await api.get("/auth/me");
        if (active) setOwner(r.data);
      } catch {
        localStorage.removeItem("rg_token");
        if (active) { setToken(null); setOwner(null); }
      } finally {
        if (active) setLoading(false);
      }
    }
    boot();
    return () => { active = false; };
  }, [token]);

  const login = (tok, own) => {
    localStorage.setItem("rg_token", tok);
    setToken(tok);
    setOwner(own);
  };
  const logout = () => {
    localStorage.removeItem("rg_token");
    setToken(null);
    setOwner(null);
  };

  return (
    <AuthCtx.Provider value={{ token, owner, loading, login, logout, setOwner }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
